// John Eldhose 20200622
import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Button, ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary, Grid, Paper, Tooltip, Typography } from '@material-ui/core';
import { CheckCircle, CloudDownload, ExpandMore, InfoOutline, PlayCircleFilled } from '@material-ui/icons';
import { postAcademy } from './lib';
import { stream } from '../../lib/lib';
import Loading from '../../lib/Loading';
import Curriculum from './Curriculum';
import Discussion from './Discussion';
import RatingEdit from './RatingEdit';
import AcademyUser from '../../../actions/AcademyUser';
import Video from '../../lib/Video';

class App extends Component {

  state = {
    loading: true,
    content: 'modules',
    custom: {},
    open: null
  }
  properties = { _course: [], _module: [] };
  componentWillMount() {
    postAcademy('Course', this.props.parms, (res) => {
      let custom = this.state.custom;
      res.data.map((prop) => {
        this.properties[prop.property].push(prop);
        custom[prop.id] = 'Loading . . .';
        axios.get('https://account.carlsonsw.com/modules/' + prop.details.file)
          .then((res) => {
            custom[prop.id] = res.data;
            this.setState({ custom: custom });
          })
          .catch((err) => {
            console.log(err);
          return false;
          })
        return true;
      });
      this.setState({ loading: false });
    });
  }
  resources = (res, id) => {
    return (
      <Paper key={id} style={{ padding: '10px' }}>
        <Grid container justify="space-between" alignItems='center'>
          <Grid item>{res}</Grid>
          <Grid item>
            <Button
              color='primary'
              onClick={(e) => window.open(stream('academy/resources/' + res, true), '_blank')}
            >
              Download <CloudDownload style={{ transform: 'scale(.7)' }} />
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  }
  completedcheck = (mod) => {
    if(this.props.user.modules.includes(mod.id))
      return (<CheckCircle style={{ transform: 'scale(.85)', color: 'green' }} />);
    else
      return (<PlayCircleFilled style={{ transform: 'scale(.85)', color: 'gray' }} />);
  }
  completed = (id) => {
    if(!this.props.user.modules.includes(id))
      this.props.AcademyUser('module', id);
    var completed = true;
    if(!this.props.user.courses.includes(this.properties._course[0].id)) {
      for(var i = 0; i < this.properties._module.length; i++)
        if(
          this.properties._module[i].id !== id &&
          !this.props.user.modules.includes(this.properties._module[i].id)
        ) {
          completed = false;
          break;
        }
        if(completed)
          this.props.AcademyUser('course', this.properties._course[0].id);
    }
    if(typeof this.props.completed !== 'undefined' && completed)
      this.props.completed(this.properties._course[0].id);
  }
  custom = (mod) => {
    this.completed(mod.id);
    return {__html: this.state.custom[mod.id]};
  }
  moduleDef = (mod) => {
    switch(mod.details.module) {
      case 'Video':
        return (
          <div style={{ width: '100%' }}>
            <Video
              src={'https://account.carlsonsw.com/modules/' + mod.details.file}
              ended={() => this.completed(mod.id)}
            />
            <p />
            <Typography variant='subheading'>{mod.description}</Typography>
          </div>
        );
      case 'Custom':
        return (
          <div style={{ width: '100%' }}>
            <div
              dangerouslySetInnerHTML={this.custom(mod)}
              height="100%"
              width="100%"
            />
            <p />
            <Typography variant='subheading'>{mod.description}</Typography>
          </div>
        );
      default:
        return (
          <Typography variant='subheading'>{mod.description}</Typography>
        );
    }
  }
  runtime = (mod) => {
    if(mod.details.runtime === '')
      return <div />
    else
      return (
        <Typography variant='caption'>
          [Runtime: {mod.details.runtime}]
        </Typography>
      );
  }
  modules = () => this.properties._module.map((mod, id) => {
    var mid = 'mid' + id;
    return (
      <ExpansionPanel
        key={mid}
        expanded={(this.state.open === mid)}
        onChange={(e, exp) => this.setState({ open: (exp ? mid : false) })}
      >
        <ExpansionPanelSummary expandIcon={<ExpandMore />}>
          <Grid container alignItems='center'>
            {this.completedcheck(mod)} &nbsp;
            <Typography>{mod.title}</Typography>
            <Tooltip title={mod.description}>
              <InfoOutline style={{ transform: 'scale(.7)' }} />
            </Tooltip>
            {this.runtime(mod)}
          </Grid>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails>
          {(this.state.open === mid) ? this.moduleDef(mod) : <div />}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  });
  content = (course) => {
    switch(this.state.content) {
      case 'discussion':
        return <Discussion parms={this.props.parms} />;
      case 'rating':
        return <RatingEdit parms={this.props.parms} />;
      case 'resources':
        return course.details.resources.map(this.resources);
      case 'modules':
      default:
        return this.modules();
    }
  }

  render() {
    if(this.state.loading)
      return <Loading />;
    else {
      return (
        <Curriculum
          backgroundColor='#555'
          curriculum={this.properties._course}
          defaultButton='modules'
          handleButton={(but) => this.setState({ content: but, open: null })}
          content={this.content}
          completed={this.props.user.courses.includes(this.properties._course[0].id)}
        />
      );
    }
  }
}

const mapStateToProps = (state) => {
  return ({ user: state.Academy.user.details });
}
const mapDispatchToProps = (dispatch) => ({
  AcademyUser: (prop, user) => dispatch(AcademyUser(prop, user))
});
const Course = connect(mapStateToProps, mapDispatchToProps)(App);

export default Course;



// WEBPACK FOOTER //
// ./src/components/home/academy/Course.js